import type { ITourStepData } from './ITourStepData';

/**
 * Данные шага из JSON-строки `step.data`. null — данных нет, JSON невалиден или не объект.
 * Принимает строку, а не шаг: редактор админки разбирает значение поля формы, плеер Front — `step.data`.
 */
export function parseStepData(data: string | null | undefined): ITourStepData | null {
    if (!data) return null;
    try {
        const parsed: unknown = JSON.parse(data);
        return typeof parsed === 'object' && parsed !== null ? parsed : null;
    } catch {
        return null;
    }
}

/**
 * Данные шага — в JSON для `step.data`. Пустые значения полей редактора (действие без типа, ветвление без
 * вариантов, навигация без адреса) отбрасываются; прочие поля — `hideOverlay`, `enableScroll`, `spotlightUnion`
 * плеера Front и те, о которых редактор ещё не знает, — сохраняются как есть.
 */
export function serializeStepData(data: ITourStepData | null): string | undefined {
    if (!data) return undefined;
    const { action, branches, navigate, nextTourCode, ...other } = data;
    const clean: Record<string, unknown> = Object.fromEntries(
        Object.entries(other).filter(([, value]) => value !== undefined),
    );
    if (action?.type) clean.action = action;
    if (branches?.length) clean.branches = branches;
    if (navigate?.url) clean.navigate = navigate;
    if (nextTourCode) clean.nextTourCode = nextTourCode;
    if (Object.keys(clean).length === 0) return undefined;
    return JSON.stringify(clean);
}
